import { Component, h } from "preact";

interface IProps {
  rowData: any[];
  columnDefs: any[];
}

export const SimpleGrid = class extends Component<IProps> {
  public render(props: IProps, state: {}) {
    return (
      <div class="table-responsive">
        <table class="table table-bordered table-thead-bordered table-striped table-hover">
          <thead>
            <tr>
              {props.columnDefs.map(item => (
                <th>
                  <div style={item.headerstyle ? item.headerstyle : ""}>
                    {item.headerName}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {props.rowData.map(row => (
              <tr>
                {props.columnDefs.map(header => (
                  <td>
                    <div class={header.cellClass ? header.cellClass : ""}>
                      {row.hlink && header.isHyperLink === true ? (
                        <a
                          href={row.hlink}
                          target="_blank"
                          style="text-decoration: underline; color: black;"
                        >
                          {row[header.field]}
                        </a>
                      ) : (
                        row[header.field]
                      )}
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
};
